<script setup lang="ts">
import SmartBarBackBtnLink from '@/components/btnLinks/SmartBarBackBtnLink.vue';
import AppBarBtn from '@/components/btns/AppBarBtn.vue';
import BarTitleText from '@/components/texts/BarTitleText.vue';
import AccountBarVMenu from '@/components/vMenus/AccountBarVMenu.vue';
import NoticesBarVMenu from '@/components/vMenus/NoticesBarVMenu.vue';
import AppBarBtnWrapper from '@/components/wrappers/AppBarBtnWrapper.vue';
import { useSidebarsStore } from '@/stores/useSidebarsStore';

const sidebarsStore = useSidebarsStore();

function handleHelpClick(): void {
  sidebarsStore.sidebars.helpcenter = !sidebarsStore.sidebars.helpcenter;
}
</script>

<template>
  <v-app-bar
    :elevation="0"
    :height="parseInt($style.appBarHeight)"
    :class="$style.smartAppBar"
  >
    <div :class="$style.appBarItems">
      <div :class="$style.leftItem">
        <SmartBarBackBtnLink />
      </div>
      <div :class="$style.titleItem">
        <BarTitleText />
        <div id="app-bar-chips"></div>
      </div>
      <div :class="$style.appBarBtns">
        <NoticesBarVMenu />
        <AppBarBtnWrapper>
          <!-- TODO :active instead of :aria-... doesn't work -->
          <AppBarBtn
            icon="mdi-help-circle-outline"
            :aria-haspopup="
              sidebarsStore.sidebars.helpcenter ? 'menu' : undefined
            "
            :aria-expanded="sidebarsStore.sidebars.helpcenter"
            @click="handleHelpClick"
          />
        </AppBarBtnWrapper>
      </div>
      <div :class="$style.accountItem">
        <AccountBarVMenu />
      </div>
    </div>
  </v-app-bar>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

:export {
  appBarHeight: variables.$appBarHeight;
}

.smartAppBar {
  background-color: colors.$color-white !important;
  border-bottom: 1px solid colors.$color-brand-100 !important;
  overflow: visible !important;
  z-index: 1010 !important;
}
  .appBarItems {
    height: 100%;
    width: 100%;
    display: flex;
  }
    .leftItem {
      border-right: 1px solid colors.$color-brand-100;
      width: 142px;
      flex-shrink: 0;
      margin-left: -1px;
    }
    .titleItem {
      padding: 0 0 0 23px;
      margin-right: auto;
      white-space: nowrap;
      display: flex;
      align-items: center;
    }
    .appBarBtns {
      margin-left: auto;
      padding-right: 10px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
    }
    .accountItem {
      border-left: 1px solid colors.$color-brand-100;
      white-space: nowrap;
    }

@media print {
  .smartAppBar {
  }
    .leftItem {
      display: none;
    }
    .appBarBtns {
      display: none;
    }
    .accountItem {
      display: none;
    }
}
</style>
